/* atd-blogs-filter.js (UI-only; no business logic)
   Added: count display + selected-tags rendering + tag removal.
*/
(() => {
  const ROOT = ".atd-all-blogs";
  const qsa = (r, s) => Array.from(r.querySelectorAll(s));
  const qs = (r, s) => r.querySelector(s);
  const getURL = () => new URL(window.location.href);

  // Parse URL (?type=a,b&product=c&application=d)
  const getParams = () => {
    const u = getURL();
    const arr = (k) =>
      (u.searchParams.get(k) || "")
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);
    return {
      q: (u.searchParams.get("q") || "").trim(),
      type: arr("type"),
      product: arr("product"),
      application: arr("application"),
      page: Math.max(1, parseInt(u.searchParams.get("page") || "1", 10) || 1),
    };
  };

  // Apply URL params → checkbox state
  const applyParamsToCheckboxes = (root, params) => {
    const wantByKey = {
      type: new Set((params.type || []).map((s) => s.toLowerCase())),
      product: new Set((params.product || []).map((s) => s.toLowerCase())),
      application: new Set(
        (params.application || []).map((s) => s.toLowerCase())
      ),
    };

    qsa(root, ".atd-filter__group").forEach((group) => {
      const key = group.dataset.filterKey;
      const want = wantByKey[key] || new Set();

      qsa(group, ".atd-filter__cb").forEach((cb) => {
        const val = (cb.value || "").trim().toLowerCase();
        cb.checked = want.has(val);
      });
    });

    const s = qs(root, ".atd-search__input");
    if (s) s.value = params.q || "";
  };

  // Update category toggle counts
  const updateToggleCounts = (root) => {
    qsa(root, ".atd-filter__group").forEach((group) => {
      const key = group.dataset.filterKey;
      const labelEl = group.querySelector(
        `.atd-filter__toggle-label[data-id="${key}"]`
      );
      if (!labelEl) return;

      const checkedCount = qsa(group, ".atd-filter__cb:checked").length;

      if (!labelEl.dataset.baseLabel) {
        labelEl.dataset.baseLabel = labelEl.textContent.trim();
      }

      const base = labelEl.dataset.baseLabel;
      labelEl.textContent =
        checkedCount > 0 ? `${base} (${checkedCount})` : base;
    });
  };

  // NEW: render selected tags
  const renderTags = (root) => {
    const tagBox = qs(root, ".atd-filter__tags");
    if (!tagBox) return;

    const checked = qsa(root, ".atd-filter__cb:checked");

    tagBox.innerHTML = "";

    checked.forEach((cb) => {
      const label = cb.value.trim();
      const key = cb.closest(".atd-filter__group").dataset.filterKey;

      const tag = document.createElement("div");
      tag.className = "atd-tag";
      tag.innerHTML = `
        <span>${label}</span>
        <button class="atd-tag__close" data-key="${key}" data-value="${label}">✕</button>
      `;
      tagBox.appendChild(tag);
    });

    if (checked.length === 0) {
      tagBox.innerHTML = "";
    }
  };

  // Close all dropdown panels
  const closePanels = (root) => {
    qsa(root, ".atd-filter__panel").forEach((p) =>
      p.setAttribute("hidden", "")
    );
  };

  const mount = (root) => {
    const tagBox = qs(root, ".atd-filter__tags");

    // Toggle popovers
    qsa(root, ".atd-filter__toggle").forEach((btn) => {
      btn.addEventListener("click", () => {
        const panel = btn.nextElementSibling;
        if (!panel) return;
        const isOpen = !panel.hasAttribute("hidden");
        closePanels(root);
        if (!isOpen) panel.removeAttribute("hidden");
      });
    });

    // Outside click close
    const onDocPointerDown = (e) => {
      if (
        e.target.closest(`${ROOT} .atd-filter__group`)?.closest(ROOT) === root
      )
        return;
      closePanels(root);
    };
    document.addEventListener("pointerdown", onDocPointerDown, true);

    const onDocKey = (e) => {
      if (e.key === "Escape") closePanels(root);
    };
    document.addEventListener("keydown", onDocKey, true);

    // Init: URL → UI
    const params = getParams();
    applyParamsToCheckboxes(root, params);
    updateToggleCounts(root);
    renderTags(root);

    // Checkbox changes
    root.addEventListener("change", (e) => {
      if (!e.target.matches(".atd-filter__cb")) return;

      updateToggleCounts(root);
      renderTags(root);

      root.dispatchEvent(
        new CustomEvent("atd:filters:changed", { bubbles: true })
      );
    });

    // Tag close buttons
    tagBox?.addEventListener("click", (e) => {
      if (!e.target.matches(".atd-tag__close")) return;

      const key = e.target.dataset.key;
      const value = e.target.dataset.value.toLowerCase();

      // Uncheck the respective checkbox
      const cb = qsa(
        root,
        `.atd-filter__group[data-filter-key="${key}"] .atd-filter__cb`
      ).find((c) => c.value.trim().toLowerCase() === value);

      if (cb) cb.checked = false;

      updateToggleCounts(root);
      renderTags(root);

      root.dispatchEvent(
        new CustomEvent("atd:filters:changed", {
          bubbles: true,
          detail: { tagRemoved: true },
        })
      );
    });

    // Reset button
    const resetBtn = qs(root, ".atd-filter__reset");
    if (resetBtn) {
      resetBtn.addEventListener("click", () => {
        qsa(root, ".atd-filter__cb").forEach((cb) => (cb.checked = false));
        const s = qs(root, ".atd-search__input");
        if (s) s.value = "";

        closePanels(root);
        updateToggleCounts(root);
        renderTags(root);

        root.dispatchEvent(
          new CustomEvent("atd:filters:changed", {
            bubbles: true,
            detail: { reset: true },
          })
        );
      });
    }

    // Cleanup
    const obs = new MutationObserver(() => {
      if (!document.body.contains(root)) {
        document.removeEventListener("pointerdown", onDocPointerDown, true);
        document.removeEventListener("keydown", onDocKey, true);
        obs.disconnect();
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  };

  // Init
  const init = () => qsa(document, ROOT).forEach(mount);
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();
